// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1JNE3","tab":"ProcedureTabs_tab__1XbA3"};